<template>
	<div>
		<ul
			v-if="travelers"
			class="list mt-4 d-flex flex-column gap-3"
			:class="isXS ? 'list-mobile' : ''"
		>
			<li class="item d-flex gap-2" v-for="traveler in travelers" :key="traveler.id">
				<Avatar :src="traveler.picture" height="32px" width="32px" />
				<div class="d-flex flex-column">
					<h3 class="text-label-m text-neutral-700">{{ traveler.name }}</h3>
					<p class="text-body-s text-neutral-500">@{{ traveler.username }}</p>
				</div>
				<Chip
					v-if="traveler.role === 'owner'"
					size="xs"
					class="chip text-secondary-500 bg-secondary-25 border-xs border-neutral-200 align-self-center"
				>
					{{ $t('C_Create_Createanitinerary_Travelers_Tag_Owner') }}
				</Chip>
				<Chip
					v-else
					size="xs"
					class="chip text-neutral-900 bg-neutral-25 border-xs border-neutral-200 align-self-center"
				>
					{{ $t('B2C_itinerarymap_invitefriends_onboardtravel_editor') }}
				</Chip>
				<Icon
					v-if="traveler.role !== 'owner'"
					data-testid="remove-traveler"
					class="align-self-center ml-1 cursor-pointer"
					icon="close"
					@click="openDeleteDialog(traveler.id)"
				/>
			</li>
		</ul>
		<Skeleton v-else class="mt-4 width-full rounded-2" style="height: 40px" />
	</div>
</template>
<script setup lang="ts">
	import { Traveler2 } from '~/models/Traveler'

	interface Props {
		travelers?: Traveler2[]
		isXS: boolean
	}
	interface Emits {
		(e: 'delete', travelerId: string): void
	}
	defineProps<Props>()
	const emit = defineEmits<Emits>()

	const openDeleteDialog = (travelerId: string) => {
		emit('delete', travelerId)
	}
</script>

<style scoped lang="scss">
	.list {
		padding-inline-start: 0;
	}

	.list-mobile {
		padding-inline-start: 0;
	}

	.item {
		list-style-type: none;
	}

	.chip {
		margin-left: auto;
		height: 32px !important;
		border-radius: 250px;
		-webkit-user-select: none;
		-moz-user-select: none;
		user-select: none;
		width: -moz-max-content;
		width: max-content;
	}
</style>
